import { Flex, Tooltip } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"
import { getDefaultCalendarColor, getEventPreviewColors, getPrimaryCalendarTextColor } from "pagesV2/pro/Calendar/calendarColorUtils"
import { useTheme } from "context/AntdThemeContext"

const EventBlock = ({
  event,
  eventColor,
  eventBorderColor,
  conflict,
  setIsBookingModalOpen,
  setSelectedBookingId,
  fullHeight,
  multipleInSlot,
  compact,
  defaultColor
}) => {
  const { id, startLabel, endLabel, title } = event || {}
  const { theme } = useTheme()

  const handleClick = () => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(event?.id)
  }

  const timeRange = startLabel && endLabel ? `${startLabel} – ${endLabel}` : null
  const tooltipTitle = [timeRange, title].filter(Boolean).join("\n")

  let timeClassName = styles.eventTime
  if (compact) timeClassName = styles.eventTimeCompact
  else if (multipleInSlot) timeClassName = styles.eventTimeWrap

  let titleClassName = styles.eventTitle
  if (compact) titleClassName = styles.eventTitleCompact
  else if (multipleInSlot) titleClassName = styles.eventTitleWrap

  const primaryTextColor = getPrimaryCalendarTextColor(theme)
  const resolvedDefault = defaultColor || getDefaultCalendarColor()
  const isCustomColor = eventColor?.startsWith("#")
  const { backgroundColor, borderColor, textColor } = isCustomColor 
    ? getEventPreviewColors(eventColor, resolvedDefault, primaryTextColor)
    : { backgroundColor: eventColor || resolvedDefault, borderColor: eventBorderColor, textColor: primaryTextColor }

  const blockClassName = compact ? `${styles.eventBlock} ${styles.eventBlockCompact}` : styles.eventBlock

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.5}>
      <button
        type="button"
        key={id || title + startLabel + endLabel}
        className={blockClassName}
        style={{
          backgroundColor,
          borderColor,
          ...(fullHeight ? { height: "100%" } : {}),
          ...(multipleInSlot ? { whiteSpace: "normal", wordBreak: "break-word" } : {})
        }}
        onClick={handleClick}
      >
        <Flex align="center" justify="space-between" gap={compact ? 2 : 4}>
          <span className={timeClassName} style={textColor ? { color: textColor } : undefined}>{startLabel} - {endLabel}</span>
          {conflict ? <BookingConflictWarning /> : null}
        </Flex>
        <span className={titleClassName} style={textColor ? { color: textColor } : undefined}>{title}</span>
      </button>
    </Tooltip>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  }),
  eventColor: PropTypes.string,
  eventBorderColor: PropTypes.string,
  defaultColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool,
  fullHeight: PropTypes.bool,
  multipleInSlot: PropTypes.bool,
  compact: PropTypes.bool
}

export default EventBlock
